/*
  Fish
  by Zainal Abd. Kahar (https://sketchfab.com/zsuperxtreme)
  via https://sketchfab.com/3d-models/fish-80d9d61f143c472b8e1522a2fd711f9e
  
  License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
  Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { useEffect, useState, type JSX } from 'react'
import type { ColorRepresentation, Material, Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Sphere_Color_0: Mesh
      Iris_Color_0: Mesh
      Tail_Color_0: Mesh
      Sphere002_Color_0: Mesh
    }
    materials: {
      Color: MeshStandardMaterial
    }
  }

type FishProps = JSX.IntrinsicElements['group'] & {
  colorA?: ColorRepresentation
  colorB?: ColorRepresentation
  colorC?: ColorRepresentation
}

export default function Fish({
  colorA = 'white',
  colorB = 'white',
  colorC = 'white',
  ...props
}: FishProps) {
  const { nodes, materials } = useGLTF('./models/fish.glb') as GLTFResult

  const [materialA, setMaterialA] = useState<Material>()
  const [materialB, setMaterialB] = useState<Material>()
  const [materialC, setMaterialC] = useState<Material>()

  useEffect(() => {
    const baseMaterial = materials.Color.clone()
    baseMaterial.map = null
    baseMaterial.metalness = 0.5
    baseMaterial.roughness = 0.8

    const materialA = baseMaterial.clone()
    const materialB = baseMaterial.clone()
    const materialC = baseMaterial.clone()

    materialA.color.set(colorA)
    materialB.color.set(colorB)
    materialC.color.set(colorC)

    setMaterialA(materialA)
    setMaterialB(materialB)
    setMaterialC(materialC)
  }, [materials, colorA, colorB, colorC])

  return (
    <group {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]} scale={0.001}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <mesh
            castShadow
            geometry={nodes.Sphere_Color_0.geometry}
            material={materialA}
            position={[0, 231.474, 6.24]}
            rotation={[-Math.PI / 2, 0, 0]}
            scale={140.754}
          />
          <mesh
            castShadow
            geometry={nodes.Tail_Color_0.geometry}
            material={materialB}
            position={[0, 238.314, -111.059]}
            rotation={[-Math.PI / 2, 1.571, 0]}
            scale={100}
          />
          <mesh
            geometry={nodes.Sphere002_Color_0.geometry}
            material={materialC}
            position={[0, 231.474, 6.24]}
            rotation={[-0.478, -0.674, 1.824]}
            scale={140.754}
          />
          <mesh
            geometry={nodes.Iris_Color_0.geometry}
            material={materials.Color}
            position={[0, 240.885, 158.506]}
            rotation={[-1.679, 0, 0]}
            scale={[12.905, 7.823, 15.739]}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('./models/fish.glb')
